<template>
  <div>
    <div class="category-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <div class="text-right">
          <p class="d-inline-flex">
            <a class="btn btn-icon btn-xls mar-rt-10" v-if="id" :title="$t('reports.export')">
              {{$t('general.download_xls') }} <img src="/static/img/export_xls.png" @click="downloadPoints">
            </a>
            <a class="btn btn-danger btn-icon delete mar-rt-10" v-if="id" @click.prevent="handleDelete">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
            <button type="submit" @click.prevent="validate" class="btn btn-icon btn-success btn mar-rt-10 save" :title="$t('settingUsers.single')">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
    </div>
    <div class="card mar-to-15" v-if="['ADMIN', 'OWNER', 'MARKETER'].includes(userRole)">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
      <form >
        <div class="card-content">
          <div class="row">
            <div class="col-md-6">

              <div class="form-group">
                <label>{{$t('marketingPromos.title')}}</label>
                <input type="text"
                       name="title"
                       :placeholder="$t('marketingPromos.title')"
                       v-validate="modelValidations.title"
                       v-model="model.title"
                       class="form-control">
                <small class="text-danger" v-if="errors.has('title')">
                  {{ getError('title') }}
                </small>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.treshold')}}</label>
                  <input type="number"
                         name="threshold"
                         :placeholder="$t('marketingPromos.treshold')"
                         v-validate="modelValidations.treshold"
                         v-model="model.treshold"
                         class="form-control">
                  <small class="text-danger" v-if="errors.has('treshold')">
                    {{ getError('treshold') }}
                  </small>
                </div>

                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.startEndDate')}}</label><br>
                  <el-date-picker type="daterange"
                                  v-model="model.fromto"
                                  value-format="yyyy-MM-dd"
                                  format="dd/MM/yyyy"
                                  :picker-options="pickerOptions">
                  </el-date-picker>
                  <small class="text-danger" v-if="errors.has('date_start')">
                    {{ getError('date_start') }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.expiry')}}</label>
                  <input type="number"
                         name="expiry"
                         :placeholder="$t('marketingPromos.expiry')"
                         v-validate="modelValidations.expiry"
                         v-model="model.expiry"
                         class="form-control">
                  <span class="help-block"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('marketingPromos.expiryInfo')}}</span>
                  <small class="text-danger" v-if="errors.has('expiry')">
                    {{ getError('expiry') }}
                  </small>
                </div>
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.multiple')}}</label>
                  <p-switch
                    v-model="model.multiple"
                    type="success">
                  </p-switch>
                  <small class="text-danger" v-if="errors.has('multiple')">
                    {{ getError('multiple') }}
                  </small>
                </div>
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.redeemFromNextOrder')}}</label>
                  <p-switch
                    v-model="model.redeem_from_next_order"
                    type="success">
                  </p-switch>
                  <small class="text-danger" v-if="errors.has('redeem_from_next_order')">
                    {{ getError('redeem_from_next_order') }}
                  </small>
                </div>
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.addFreeProductAutomatically')}}</label>
                  <p-switch
                    v-model="model.add_free_product_auto"
                    type="success">
                  </p-switch>
                  <small class="text-danger" v-if="errors.has('add_free_product_auto')">
                    {{ getError('add_free_product_auto') }}
                  </small>
                </div>
                <div class="col-md-6 form-group">
                  <label>{{$t('marketingPromos.allowOnePointPerOrder')}}</label><br>
                  <p-switch
                    v-model="model.allow_one_point_per_order"
                    type="success">
                  </p-switch>
                </div>
              </div>
              <div class="form-group">
                  <label>{{$t('marketingPromos.image')}}</label>
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="2"
                    :file-list="model.imagelist"
                    list-type="picture-card"
                    accept=".jpg, .jpeg, .png"
                    :on-change="handleImgChnage"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <img src="/static/img/icons/icon-plus-primary.png">
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}{{$t('validations.imageResolution')}}</div>
                  </el-upload>
                  <small class="text-danger" v-if="errors.has('image')">
                    {{ getError('image') }}
                  </small>
                </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('marketingPromos.description')}}</label>
                <textarea
                      rows="5"
                      name="description"
                      :placeholder="$t('marketingPromos.descriptionPlaceholder')"
                      v-validate="modelValidations.description"
                      v-model="model.description"
                      class="form-control">
                </textarea>
                <small class="text-danger" v-if="errors.has('description')">
                  {{ getError('description') }}
                </small>
              </div>
              <div class="form-group">
                <label>{{$t('marketingPromos.notificationText')}}</label>
                <textarea
                      rows="5"
                      name="notification_text"
                      :placeholder="$t('marketingPromos.notificationTextPlaceholder')"
                      v-model="model.notification_text"
                      class="form-control">
                </textarea>
              </div>
              <div class="form-group">
                <label>{{$t('marketingPromos.location')}}</label>
                <v-select v-model="locations_formatted"
                            multiple
                            @input="onLocationsInput"
                            :options="locations"
                            value="token"
                            label="name">
                  </v-select>
                <small class="text-danger" v-if="errors.has('location')">
                  {{ getError('location') }}
                </small>
              </div>

              <div class="form-group" v-if="this.route.name != 'Edit Promo'">
                <label>{{$t('marketingPromos.code')}}</label>
                <input type="text"
                       v-validate="modelValidations.qr_code"
                       v-model="model.qr_code"
                       ref="qrCode"
                       class="form-control"/>
                <small class="text-danger" v-if="errors.qr_code">
                  {{ getError('qr_code') }}
                </small>
                <button   class="btn btn-purple mar-to-10 mar-bt-10 generate-code" @click.prevent="generateCode()">{{$t('marketingPromos.generateQrCode')}}</button>

              </div>
              <div class="col-md-12 pl-0 ml-15n" v-else>
                <div>
                  <img v-bind:src="model.qr_code">
                </div>
                <!-- <button class="btn btn-purple mar-to-10 mar-bt-10 generate-code" @click.prevent="printQrCode()">{{$t('marketingPromos.print')}}</button> -->
                <a class="btn btn-info btn-icon duplicate-prod ml-15 mar-to-10 mar-bt-10" download :href="this.model.qr_code" target="_blank">{{$t('upload.download')}}</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('marketingPromos.to_order')}}</label>
                <el-tree
                  :data="toOrder"
                  :props="treeConfig"
                  :check-strictly="false"
                  :filter-node-method="filterNode"
                  @node-expand="loadProducts"
                  @check-change="validateOrder"
                  :default-checked-keys="orderItems"
                  class="el-product-border filter-tree"
                  node-key="id"
                  ref="order"
                  show-checkbox
                  accordion
                >
                </el-tree>
                <div class="buttons mar-to-5">
                  <el-button @click="checkAll()">{{ $t('marketingCampaigns.checkAll') }}</el-button>
                  <el-button @click="resetProductTree()">{{ $t('general.reset') }}</el-button>
                </div>
              </div>
              <small class="text-danger" v-if="errorTree">
                {{ errorTree }}
              </small>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('marketingPromos.to_receive')}}</label>
                <el-tree
                  :data="toReceive"
                  :props="treeConfig"
                  :check-strictly="false"
                  :filter-node-method="filterNodeReceive"
                  @node-expand="loadProductsReceive"
                  @check-change="validateReceive"
                  :default-checked-keys="receiveItems"
                  class="el-product-border filter-tree"
                  node-key="id"
                  ref="receive"
                  show-checkbox
                  accordion
                >
                </el-tree>
                <div class="buttons mar-to-5">
                  <el-button @click="checkAllReceive()">{{ $t('marketingCampaigns.checkAll') }}</el-button>
                  <el-button @click="resetProductTreeReceive()">{{ $t('general.reset') }}</el-button>
                </div>
              </div>
              <small class="text-danger" v-if="errorTreeReceive">
                {{ errorTreeReceive }}
              </small>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card" v-if="users.length || ['LOCATION_ADMIN', 'OWNER', 'MARKETER'].includes(userRole)">
      <div class="card-header">
      </div>
      <div class="card-content row">
        <div class="col-sm-12">
          <div class="pull-left">
            <el-input v-model="filters[0].value" :placeholder="$t('reports.search')" class="icon-search mar-bt-15"></el-input>
          </div>
        </div>
        <data-tables class=""
                     v-loading="loading"
                     :data="users"
                     :search-def="defaultSearchDef()"
                     :action-def="defaultActionDef()"
                     :pagination-def="paginationDef"
                     :table-props="{'border': false}"
                     :filters="filters"
                     style="width: 100%">
          <el-table-column
            :min-width="55"
            sortable
            prop="firstname"
            :label="$t('marketingPromos.firstname')">
          </el-table-column>
          <el-table-column
            :min-width="55"
            sortable
            prop="lastname"
            :label="$t('marketingPromos.lastname')">
          </el-table-column>
          <el-table-column
            :min-width="55"
            sortable
            prop="email"
            :label="$t('marketingPromos.email')">
          </el-table-column>
          <el-table-column
            :min-width="25"
            sortable
            prop="points"
            :label="$t('marketingPromos.points')">
            <template slot-scope="props">
              <input type="text"
                    name="title"
                    :placeholder="$t('marketingPromos.title')"
                    :value="props.row.points"
                    :model="model.points"
                    :ref="props.row.id"
                    class="form-control"  v-if="props.row.waiting_approval">
              <div v-if="!props.row.waiting_approval">{{ props.row.points }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :width="110">
            <template slot-scope="props">
              <div class="d-flex" v-if="props.row.waiting_approval">
                <button type="button" @click.prevent="handleApprove(0, props.row)" :title="$t('general.add')" class="btn btn-success btn-icon">
                  <i class="ti-check"></i>
                </button>
                <button type="button" @click.prevent="handleApprove(1, props.row)" :title="$t('general.cancel')" class="btn btn-danger btn-icon">
                  <i class="ti-close"></i>
                </button>
              </div>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {mapFields} from 'vee-validate'
import {Input, Upload, Button, DatePicker, Checkbox, CheckboxGroup, Dialog} from 'element-ui'
import FileInput from 'src/components/UIComponents/Inputs/FileInput.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
// import moment from 'moment'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
    FileInput,
    [PSwitch.name]: PSwitch
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapFields(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])
  },
  data () {
    return {
      id: this.route.params.id || null,
      locations_formatted: [],
      isInitializingLocations: true,
      categoriesRequestKey: null,
      categoriesRequestInFlightKey: null,
      apiUrl: '',
      seen: false,
      filteredProd: [],
      timeout_promo: 0,
      pickerOptions1: {},
      pickerNames: ['date_validfrom', 'date_validto'],
      userRole: this.$session.get('userDataRole'),
      pickerOptions: {
        disabledDate (time) {
          if ((time.getTime() + 86401 * 1000) < Date.now()) {
            return true
          } else {
            return false
          }
        }
      },
      users: [],
      model: {
        qr_code: '',
        multiple: false,
        redeem_from_next_order: false,
        add_free_product_auto: false,
        allow_one_point_per_order: false,
        notification_text: ''
      },
      filelist: [],
      expandOrder: [],
      expandReceive: [],
      filelistToUpload: [],
      generalSuccess: '',
      locations: [],
      toOrder: [],
      toReceive: [],
      treeConfig: {
        id: 'id',
        label: 'name',
        isLeaf: 'leaf',
        level: 'level',
        children: 'children',
        loading: false,
        loadedOnce: false
      },
      modelValidations: {
        title: {
          required: true,
          min: 4
        },
        treshold: {
          required: true
        },
        expiry: {
          required: true
        },
        location: {
          required: true
        },
        qr_code: {
          required: true,
          min: 4
        }
      },
      products: [],
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      errorTree: null,
      errorTreeReceive: null,
      filters: [
        {
          value: '',
          prop: ['firstname', 'lastname', 'email', 'points']
        }
      ],
      receiveItems: [],
      orderItems: [],
      heartbeatSet: false
    }
  },
  created: function () {
    this.apiUrl = process.env.API_BASE_URL

    this.$nextTick(function () { this.loading = true })

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    }

    this.apiRequest('/product', 'GET', data, (response) => {
      if (response.status === true) {
        this.products = response.data
      }
    })
    // get promo data
    if (this.route.params.id) {
      this.apiRequest('/promo/' + this.route.params.id, 'GET', data, (response) => {
        if (response.status === true) {
          if (response.data[0].date_start && response.data[0].date_end) {
            response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end]
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{url: response.data[0].image}]
          } else {
            response.data[0].imagelist = []
          }
          this.model = response.data[0]
          this.model.multiple = !!Number(this.model.multiple)
          this.model.redeem_from_next_order = !!Number(this.model.redeem_from_next_order)
          this.model.add_free_product_auto = !!Number(this.model.add_free_product_auto)
          this.model.allow_one_point_per_order = !!Number(this.model.allow_one_point_per_order)
          this.locations_formatted = response.data[0].locations_formatted
          // this.getLocations()
          // this.getCategories()

          // if (this.model.location) {
          this.getLocations().then(() => {
            // this.locations_formatted = this.locations.filter(item => {
            //   return this.model.location.includes(item.token)
            // })
            this.isInitializingLocations = false
            this.getCategories()
          })
          // }

          this.model.product_id = JSON.parse(this.model.product_id)
          this.filteredProd = response.data[0].filteredProd
          this.users = response.data[0].users
          this.receiveItems = Object.values(this.model.receive_product).concat(Object.values(this.model.receive_category))
          this.orderItems = Object.values(this.model.order_product).concat(Object.values(this.model.order_category))
          this.$nextTick(function () { this.loading = false })
        }
        this.timeout_promo = setTimeout(() => {
          this.heartbeat()
        }, 300000) // 300000ms = 5min
      })
    } else {
      this.getLocations().finally(() => {
        this.isInitializingLocations = false
      })
      this.$nextTick(function () { this.loading = false })
    }
    // this.getCategories()
  },
  mounted () {
    // this.$nextTick(() => {
    //   if (!this.heartbeatSet) {
    //     this.heartbeat()
    //     this.heartbeatSet = true
    //   }
    // })
  },
  beforeDestroy: function () {
    clearTimeout(this.timeout_promo)
  },
  methods: {
    onLocationsInput () {
      if (this.isInitializingLocations) return
      this.getCategories()
    },
    downloadPoints () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/reports/points/export/' + this.route.params.id, 'GET', data, response => {
        const link = document.createElement('a')
        link.href = response.file
        link.setAttribute('download', response.file_name)
        document.body.appendChild(link)
        link.click()
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    checkAll () {
      const nodes = this.$refs.order.store.root.childNodes // Get all top-level nodes
      const checkedKeys = nodes.map(node => node.key) // Get the key of each top-level node
      this.$refs.order.setCheckedKeys(checkedKeys) // Set the checked keys
    },
    resetProductTree () {
      this.$refs.order.setCheckedKeys([])
    },
    getCategories () {
      let locationsIDs = this.getLocationArray()
      const requestKey = JSON.stringify({
        location_ids: (locationsIDs || []).slice().sort(),
        receive: (this.receiveItems || []).slice().sort(),
        order: (this.orderItems || []).slice().sort()
      })
      if (this.categoriesRequestInFlightKey === requestKey || this.categoriesRequestKey === requestKey) return
      this.categoriesRequestInFlightKey = requestKey

      let groupData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        usage_for_products: this.receiveItems,
        location_ids: locationsIDs
      }
      this.apiRequest('/get-tree?action=receive-products', 'GET', groupData, (response) => {
        if (response.status === true) {
          this.toReceive = response.data.tree
          this.expandReceive = Object.values(response.data.expand)
        }
      })
      groupData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        usage_for_products: this.orderItems,
        location_ids: locationsIDs
      }
      this.apiRequest('/get-tree?action=order-products', 'GET', groupData, (response) => {
        if (response.status === true) {
          this.toOrder = response.data.tree
          this.expandOrder = Object.values(response.data.expand)
        }
        this.categoriesRequestKey = requestKey
        this.categoriesRequestInFlightKey = null
      })
    },
    getLocations () {
      return new Promise((resolve, reject) => {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/get-locations', 'GET', data, (response) => {
          if (response.status) {
            this.locations = response.data
            resolve()
          } else {
            reject(new Error('Failed to fetch locations'))
          }
        })
      })
    },
    loadProducts (node) {
      let treeNode = this.$refs.order.getNode(node)
      let locationsIDs = this.getLocationArray()
      if (!this.expandOrder.includes(node.id) && !node.loadedOnce) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          location_ids: locationsIDs
        }
        node.loading = true
        this.apiRequest('/product-tree-products', 'GET', data, (response) => {
          if (response.status) {
            node.children = response.data
            node.expand = true
            node.loading = false
            node.loadedOnce = true
            this.$nextTick(() => {
              if (treeNode.checked) {
                this.$refs.order.setCheckedNodes(this.$refs.order.getCheckedNodes().concat(treeNode.children))
              }
            })
          }
        })
      }
    },
    filterNode (value, data) {
      if (!value) return true
      // search node label
      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true
      }
      // search children labels recursively
      if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
          if (this.filterNode(value, data.children[i])) {
            return true
          }
        }
      }
      return false
    },
    // TO RECEIVE
    checkAllReceive () {
      const nodes = this.$refs.receive.store.root.childNodes // Get all top-level nodes
      const checkedKeys = nodes.map(node => node.key) // Get the key of each top-level node
      this.$refs.receive.setCheckedKeys(checkedKeys) // Set the checked keys
    },
    resetProductTreeReceive () {
      this.$refs.receive.setCheckedKeys([])
    },
    loadProductsReceive (node) {
      let treeNode = this.$refs.receive.getNode(node)
      let locationsIDs = this.getLocationArray()
      if (!this.expandReceive.includes(node.id) && !node.loadedOnce) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          location_ids: locationsIDs
        }
        node.loading = true
        this.apiRequest('/product-tree-products', 'GET', data, (response) => {
          if (response.status) {
            node.children = response.data
            node.expand = true
            node.loading = false
            node.loadedOnce = true
            this.$nextTick(() => {
              if (treeNode.checked) {
                this.$refs.receive.setCheckedNodes(this.$refs.receive.getCheckedNodes().concat(treeNode.children))
              }
            })
          }
        })
      }
    },
    filterNodeReceive (value, data) {
      if (!value) return true
      // search node label
      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true
      }
      // search children labels recursively
      if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
          if (this.filterNodeReceive(value, data.children[i])) {
            return true
          }
        }
      }
      return false
    },
    //
    handleApprove (flag, row, points) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        waiting_approval: flag,
        rowId: row.id,
        points: this.$refs[row.id].value
      }

      var self = this

      this.apiRequest('/promo_client/' + row.id, 'PUT', data, function (response) {
        if (response.status) {
          row.waiting_approval = !row.waiting_approval
          row.points = response.data[0].points
          swal(
            self.$t('general.success') + '!',
            '',
            'success'
          ).catch(() => {})
          var id = self.$route.params.id
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany')
          }
          self.apiRequest('/promo/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              self.users = response.data[0].users
              self.loading = false
            }
          })
        } else {
          swal(
            '',
            self.$t('validations.wentWrong'),
            'error'
          ).catch(() => {})
          row.waiting_approval = !row.waiting_approval
        }
      })
    },
    heartbeat: function () {
      var self = this
      var id = this.route.params.id

      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/promo/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            self.users = response.data[0].users
            self.loading = false
          }
          self.timeout_promo = setTimeout(() => {
            self.heartbeat()
          }, 8000)
        })
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.errors.clear()
          this.savePromo()
        }
      })
    },
    validateOrder () {
      let checkedKeys = this.$refs.order.getCheckedKeys()
      if (checkedKeys.length === 0) {
        this.errorTree = this.$t('marketingCampaigns.productTreeError')
        return false
      } else {
        this.errorTree = null
        return true
      }
    },
    validateReceive () {
      let checkedKeys = this.$refs.receive.getCheckedKeys()
      if (checkedKeys.length === 0) {
        this.errorTreeReceive = this.$t('marketingCampaigns.productTreeError')
        return false
      } else {
        this.errorTreeReceive = null
        return true
      }
    },
    handleErrors (errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0])
        } else {
          this.errors.add(prop, errors[prop])
        }
      }
    },
    isNew () {
      if (this.route.params.id) {
        return false
      } else {
        return true
      }
    },
    handleImgChnage (file, fileList) {
      // const isJPG = file.type === 'image/jpeg'
      const isOkSize = file.size / 1024 / 1024 < 5
      var self = this
      if (!isOkSize) {
        swal({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
        this.$refs.upload.clearFiles()
        this.model.imagelist = []
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1)
        } else {
          this.model.imagelist = fileList
        }
      }

      if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(
          (base64enc) => {
            this.model.image = base64enc
          }
        )
      }
    },
    handleRemove (file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = []
        this.model.image = null
      }
    },
    uploadImage (upload) {
    },
    handleExceed (files, fileList) {
      swal({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      })
    },
    beforeUpload (file) {
      const isOkSize = file.size / 1024 / 1024 < 5
      var self = this
      if (!isOkSize) {
        swal({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
      }
      return isOkSize
    },
    handleDelete (label) {
      var btnCounter = 3
      var self = this
      swal({
        text: self.$t('marketingPromos.areYouSureDelete', {label: label}),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              // self.$router.push('/marketing/promos')
              self.$bus.$emit('refresh')
              self.$bus.$emit('close-modal')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/promo/' + id, 'DELETE', data, function (response) {
                // console.warn(response)
                if (response.status === true) {
                  swal(
                    '',
                    self.$t('validations.offerDeleted'),
                    'success'
                  )
                  // self.$router.push('/marketing/promos')
                  self.$bus.$emit('refresh')
                  self.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
      swal.disableConfirmButton()

      var btnInterval = setInterval(function () {
        btnCounter--

        if (btnCounter >= 1) {
          swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
        } else {
          swal.getConfirmButton().textContent = self.$t('general.yes')
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    },
    clearLinkSelection () {
      // console.warn('clean')
      this.model.link_id = null
      this.model.description = null
    },
    generateCode () {
      var random = Math.random().toString(36).substring(7)
      this.model['qr_code'] = random
    },
    getLocationArray () {
      return (this.locations_formatted && this.locations_formatted.length) ? this.locations_formatted.map(el => el.token) : []
    },
    savePromo () {
      this.$nextTick(function () { this.loading = true })
      let checkedNodes = this.$refs.order.getCheckedNodes()

      const orderCategory = checkedNodes.reduce((acc, node) => {
        if (node.level === 1) {
          acc.push(node.id)
        }
        return acc
      }, [])

      const order = checkedNodes
        .filter(node => node.level === 2)
        .filter(node => {
          let parent = this.$refs.order.getNode(node).parent
          return !orderCategory.includes(parent.data.id)
        })
        .map(node => node.id)

      checkedNodes = this.$refs.receive.getCheckedNodes()

      const receiveCategory = checkedNodes.reduce((acc, node) => {
        if (node.level === 1) {
          acc.push(node.id)
        }
        return acc
      }, [])

      const receive = checkedNodes
        .filter(node => node.level === 2)
        .filter(node => {
          let parent = this.$refs.receive.getNode(node).parent
          return !receiveCategory.includes(parent.data.id)
        })
        .map(node => node.id)
      if (order.length === 0 && orderCategory.length === 0) {
        swal(
          {
            title: '',
            text: this.$t('marketingPromos.toOrderError'),
            type: 'error',
            showConfirmButton: true
          }
        )
        this.$nextTick(function () { this.loading = false })
        return
      }

      if (receive.length === 0 && receiveCategory.length === 0) {
        swal(
          {
            title: '',
            text: this.$t('marketingPromos.toReceiveError'),
            type: 'error',
            showConfirmButton: true
          }
        )
        this.$nextTick(function () { this.loading = false })
        return
      }

      let locationsIDs = this.getLocationArray()
      var data = {
        title: this.model.title,
        image: this.model.image,
        treshold: this.model.treshold,
        qr_code: this.model.qr_code,
        active: this.model.active,
        description: this.model.description,
        notification_text: this.model.notification_text,
        location: locationsIDs,
        multiple: this.model.multiple ? 1 : 0,
        redeem_from_next_order: this.model.redeem_from_next_order ? 1 : 0,
        add_free_product_auto: this.model.add_free_product_auto ? 1 : 0,
        allow_one_point_per_order: this.model.allow_one_point_per_order ? 1 : 0,
        order_product: order,
        receive_product: receive,
        order_category: orderCategory,
        receive_category: receiveCategory,
        expiry: this.model.expiry
      }

      data.token = this.$session.get('token')
      data.company_id = this.$session.get('selectedCompany')

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.date_start = this.model.fromto[0]
        data.date_end = this.model.fromto[1]
      } else {
        data.date_start = null
        data.date_end = null
      }

      var self = this

      if (this.isNew()) {
        data.sort_order = 0
        if (this.model.image) {
          this.apiRequest('/promo', 'POST', data, (response) => {
            if (response.status === true) {
              this.$nextTick(function () { this.loading = false })
              this.backButton()
              swal(
                {
                  title: '',
                  text: this.$t('marketingPromos.promoAdded'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
              // var id = response.data[0].id
              // this.router.push('/marketing/promos/edit/' + id)
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              this.$nextTick(function () { this.loading = false })
              this.handleErrors(response.errors)
            }
          }) // end api response
        } else {
          this.$nextTick(function () { this.loading = false })
          this.errors.add('image', this.$t('marketingPromos.validImg'))
        }
      } else {
        var id = this.route.params.id
        // check if the've removed the picture
        if (this.model.imagelist === 0) {
          data.image = ''
        }
        if (self.model.image) {
          self.apiRequest('/promo/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.$nextTick(function () { self.loading = false })
              self.backButton()
              swal(
                {
                  title: '',
                  text: self.$t('marketingPromos.promoUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            } else {
              self.$nextTick(function () { self.loading = false })
              swal(
                {
                  title: '',
                  text: self.$t('marketingPromos.weCouldNot'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          }) // end api response
        } else {
          this.apiRequest('/promo/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.$nextTick(function () { self.loading = false })
              self.backButton()
              swal(
                {
                  title: '',
                  text: self.$t('marketingPromos.promoUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {})
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      }
    },
    backButton () {
      // this.router.push('/marketing/promos')
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    }
  }
}
</script>
<style scoped>
.ml-15{
  margin-left: 15px;
}
.pl-0 {
  padding-left: 0px;
}

.ml-15n {
  margin-left: -15px;
}

.el-date-editor {
  width:100% !important;
}

.content {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Promos/PromosForm.vue